import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live list of all tenants. Only HQ admins may list the whole collection (the
// tenants read rule passes for hqadmin on every doc); owners use their own
// tenantIds instead. Used by the HQ Tenants view + the HQ tenant switcher.
export function subscribeTenants(onChange, onError) {
  return onSnapshot(
    collection(db, 'tenants'),
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('tenants listener error', err)),
  );
}
